<template>
    <transition
        enter-active-class="duration-300 ease-out"
        enter-from-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
        leave-active-class="duration-200 ease-in"
        leave-from-class="translate-y-0 opacity-100 sm:scale-100"
        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
    >
        <span
            v-show="notificationAreaHasUnread"
            class="notification-count"
            :class="[notificationAreaHasUnread ? 'has-unread' : 'has-read']"
        >
            {{ notificationArea.unreadCount }}
        </span>
    </transition>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useNotificationArea } from '@src/Notifications/Pages/composables/useNotificationArea';

const notificationArea = useNotificationArea();
const notificationAreaHasUnread = computed(() => notificationArea.hasUnread.value);
</script>
